export const API_PATH_apiUsersInvitationsGet = '/services/users-invitations';
